import {atomWithReset} from 'jotai/utils'

export const timestampGameStartedState = atomWithReset<number | null>(null)
export const timestampGameEndedState = atomWithReset<number | null>(null)

export const timestampSlot1FinishState = atomWithReset<number | null>(null)
export const timestampSlot2FinishState = atomWithReset<number | null>(null)
export const timestampSlot3FinishState = atomWithReset<number | null>(null)
export const timestampSlot4FinishState = atomWithReset<number | null>(null)
export const timestampSlot5FinishState = atomWithReset<number | null>(null)
